<template>
    <div>
      <trademark-nice-class-form :getTrademarkList="getTrademarkList" :getTrademarkNiceClassList="getTrademarkNiceClassList" ref="trademarkNiceClassFormModal"></trademark-nice-class-form>
      <b-row>
        <b-col class="col-12">
          <div style="float:right;" class="custom-search d-flex justify-content-end">
            <b-form-group>
              <div class="d-flex align-items-center">
                <b-button style="float:right;" size="sm" variant="outline-primary"
                  @click="getInfo(0)">{{ $t('trademarkNiceClass.add') }}</b-button>
              </div>
            </b-form-group>
          </div>
        </b-col>
      </b-row>
      <!-- table -->
      <vue-good-table 
      id="trademarkNiceClassTable"
      ref="trademarkNiceClassTable" 
      :columns="columns" 
      :rows="rows"
      styleClass="vgt-table condensed tableSize"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }" 
        theme="my-theme">
        <div slot="emptystate">
          {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
          <span v-if="props.column.field === 'niceClassType'" class="text-nowrap">
            {{ $t('trademarkNiceClass.type') }}
          </span>
          <span v-else-if="props.column.field === 'niceClass'" class="text-nowrap">
            {{ $t('trademarkNiceClass.nice_class') }}
          </span>
          <span v-else-if="props.column.field === 'goods'" class="text-nowrap">
            {{ $t('trademarkNiceClass.goods') }}
          </span>
          <span v-else-if="props.column.field === 'goodsEn'" class="text-nowrap">
            {{ $t('trademarkNiceClass.goods_en') }}
          </span>
          <span v-else-if="props.column.field === 'extractedGoods'" class="text-nowrap">
            {{ $t('trademarkNiceClass.extracted_goods') }}
          </span>
          <span v-else-if="props.column.field === 'process'" class="text-nowrap">
            {{ $t('others.process') }}
          </span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
          <span style="white-space: pre-line;" v-if="props.column.field === 'goods'" v-html="$truncateText(props.row.goods, 100)"></span>
          <span style="white-space: pre-line;" v-else-if="props.column.field === 'goodsEn'" v-html="$truncateText(props.row.goodsEn, 100)"></span>
          <span style="white-space: pre-line;" v-else-if="props.column.field === 'extractedGoods'" v-html="$truncateText(props.row.extractedGoods, 100)"></span>
          <!-- Column: Process -->
          <span v-else-if="props.column.field === 'process'">
            <span>
              <b-button v-b-tooltip.html :title="$t('others.edit')" v-b-modal.modal-top variant="primary"
              class="btn-icon mb-1 ml-1" size="sm" @click="getInfo(props.row.id)">
              <feather-icon icon="EditIcon" />
            </b-button>
              <b-button v-b-tooltip.html :title="$t('others.delete')" variant="warning" class="btn-icon mb-1 ml-1"
                size="sm" @click="deleted(props.row)">
                <feather-icon icon="XIcon" />
              </b-button>
            </span>
          </span>
        </template>
      </vue-good-table>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      trademarkId: Number,
      getTrademarkList: {type: Function},
    },
    data() {
      return {
        dir: false,
        columns: [
          {
            label: this.$t('trademarkNiceClass.type'),
            field: `niceClassType`,
          },
          {
            label: this.$t('trademarkNiceClass.nice_class'),
            field: `niceClass`,
          },
          {
            label: this.$t('trademarkNiceClass.goods'),
            field: `goods`,
          },
          {
            label: this.$t('trademarkNiceClass.goods_en'),
            field: `goodsEn`,
          },
          {
            label: this.$t('trademarkNiceClass.extracted_goods'),
            field: `extractedGoods`,
          },
          {
            label: 'Process',
            field: 'process',
            width: '10em'
          },
        ],
        rows: [],
        searchTerm: '',
        niceClass: [],
      }
    },
    mounted() {
      this.getTrademarkNiceClassList()
    },
    methods: {
      async deleted(data) {
        data = { id: data.id }
        const controller = { name: 'TrademarkNiceClass' }
        const payload = { data: data, controller: controller }
        this.$DeleteConfirm().then(result => {
          if (result.value) {
            this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
              if (response.data.resultStatus == true) {
                this.$DeleteAlert()
                this.getTrademarkNiceClassList()
                this.getTrademarkList()
              } else {
                this.$WarningAlert(response.data.resultMessage)
                this.getTrademarkNiceClassList()
              }
            })
          }
        })
      },
      async getInfo(id) {
        this.$refs.trademarkNiceClassFormModal.showInfo(id, this.trademarkId )
      },
      getTrademarkNiceClassList() {
        this.rows = [] 
        const data = { id: this.trademarkId }
        const controller = { name: 'TrademarkNiceClass', actionName:'GetTrademarkNiceClassListByTrademarkId' }
        const payload = { data: data, controller: controller }
        this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
            if (response.data.resultStatus == true) {
              response.data.trademarkNiceClassList.forEach(element => {
                this.rows.push(element)
              })
                if(response.data.trademarkNiceClassList.length > 0){
                  this.niceClass = response.data.trademarkNiceClassList[0].niceClass
                  this.$emit('niceClassFromChild', this.niceClass)
                  new Promise(resolve => setTimeout(resolve, 1000));
                }
            } else {
              this.$WarningAlert(response.data.resultMessage)
            }
          })
      },
    },
  }
  </script>
  <style lang="scss" >
    .tableSize {
      font-size: 13px!important;
      border-collapse: collapse;
      width: 100%;
      max-width: 100%;
      table-layout: auto;
  }
  </style>
  